import { SalesPipelineStage } from '€lib/stages/types';

interface StageGroups {
    [name: string]: number;
}

export default {
    [SalesPipelineStage.Prospect]: 1,

    [SalesPipelineStage.LeadQualification]: 2,
    [SalesPipelineStage.ProductSourcing]: 2,

    [SalesPipelineStage.Proposal]: 3,
    [SalesPipelineStage.Processing]: 3,

    [SalesPipelineStage.Commitment]: 4,

    [SalesPipelineStage.Closeout]: 5,
    [SalesPipelineStage.Won]: 5,

    [SalesPipelineStage.Lost]: 6,

    [SalesPipelineStage.OnHold]: 7,
} as StageGroups;
